import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type VendorPurchaseOrderItemFieldsFragment = { __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason };

export type VendorPurchaseOrderChargeFieldsFragment = { __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number };

export type VendorPurchaseOrderReceiptFieldsFragment = { __typename?: 'VendorPurchaseOrderReceiptData', itemId: string, quantity: number, qualityNotes?: string | null, receiptEntryId: string, receivedDate: Types.TDateISO, receiveLocationId: string, shortageNotes?: string | null, varianceReason: Types.VendorReceiveVarianceReason, vendorLotNumber?: string | null };

export type VendorPurchaseOrderFieldsFragment = { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> };

export type VendorPurchaseOrderDetailFieldsFragment = { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, receipts: Array<{ __typename?: 'VendorPurchaseOrderReceiptData', itemId: string, quantity: number, qualityNotes?: string | null, receiptEntryId: string, receivedDate: Types.TDateISO, receiveLocationId: string, shortageNotes?: string | null, varianceReason: Types.VendorReceiveVarianceReason, vendorLotNumber?: string | null }>, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> };

export type GetVendorPurchaseOrdersQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.VendorPurchaseOrderDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.VendorPurchaseOrderDocumentSortInput> | Types.VendorPurchaseOrderDocumentSortInput>;
}>;


export type GetVendorPurchaseOrdersQuery = { __typename?: 'Query', vendorPurchaseOrders?: { __typename?: 'VendorPurchaseOrdersConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, nodes?: Array<{ __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> }> | null } | null };

export type GetVendorPurchaseOrderQueryVariables = Types.Exact<{
  vendorPurchaseOrderId: Types.Scalars['String']['input'];
}>;


export type GetVendorPurchaseOrderQuery = { __typename?: 'Query', vendorPurchaseOrderById?: { __typename?: 'VendorPurchaseOrderDocument', created: Types.TDateISO, erpId: string, id: string, orderPlacedDate: Types.TDateISO, purchaseOrderNumber: string, siteLocationId: string, status: Types.VendorPurchaseOrderStatus, tenantId: string, updated: Types.TDateISO, vendorId: string, vendorName: string, isUrgent: boolean, estimatedSubtotal: number, estimatedTotal: number, needByDate?: string | null, shipWeek?: number | null, notes: string, receipts: Array<{ __typename?: 'VendorPurchaseOrderReceiptData', itemId: string, quantity: number, qualityNotes?: string | null, receiptEntryId: string, receivedDate: Types.TDateISO, receiveLocationId: string, shortageNotes?: string | null, varianceReason: Types.VendorReceiveVarianceReason, vendorLotNumber?: string | null }>, billingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, shippingAddress?: { __typename?: 'AddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null, items: Array<{ __typename?: 'VendorPurchaseOrderItemData', erpJobId: string, eventDetailId?: string | null, id: string, isCostOverridden: boolean, isOrganicAtReceive: boolean, itemName: string, lineNumber: number, materialItemErpId: string, materialItemId: string, organicLotCode?: string | null, productionJobId?: string | null, productionJobNumber?: number | null, quantityOrdered: number, quantityReceived: number, unitCost?: number | null, unitCostText?: string | null, varianceReason: Types.VendorReceiveVarianceReason }>, charges: Array<{ __typename?: 'VendorPurchaseOrderChargeData', id: string, label: string, amount: number }> } | null };

export type GetVendorPurchaseOrderLineCostPreviewQueryVariables = Types.Exact<{
  vendorId: Types.Scalars['String']['input'];
  materialItemIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
  asOfDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
}>;


export type GetVendorPurchaseOrderLineCostPreviewQuery = { __typename?: 'Query', vendorPurchaseOrderLineCostPreview: Array<{ __typename?: 'VendorPurchaseOrderLineCostPreview', materialItemId: string, unitCost?: number | null, unitCostText?: string | null }> };

export const VendorPurchaseOrderItemFieldsFragmentDoc = new TypedDocumentString(`
    fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
    `, {"fragmentName":"VendorPurchaseOrderItemFields"});
export const VendorPurchaseOrderChargeFieldsFragmentDoc = new TypedDocumentString(`
    fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}
    `, {"fragmentName":"VendorPurchaseOrderChargeFields"});
export const VendorPurchaseOrderFieldsFragmentDoc = new TypedDocumentString(`
    fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
    fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`, {"fragmentName":"VendorPurchaseOrderFields"});
export const VendorPurchaseOrderReceiptFieldsFragmentDoc = new TypedDocumentString(`
    fragment VendorPurchaseOrderReceiptFields on VendorPurchaseOrderReceiptData {
  itemId
  quantity
  qualityNotes
  receiptEntryId
  receivedDate
  receiveLocationId
  shortageNotes
  varianceReason
  vendorLotNumber
}
    `, {"fragmentName":"VendorPurchaseOrderReceiptFields"});
export const VendorPurchaseOrderDetailFieldsFragmentDoc = new TypedDocumentString(`
    fragment VendorPurchaseOrderDetailFields on VendorPurchaseOrderDocument {
  ...VendorPurchaseOrderFields
  receipts {
    ...VendorPurchaseOrderReceiptFields
  }
}
    fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}
fragment VendorPurchaseOrderReceiptFields on VendorPurchaseOrderReceiptData {
  itemId
  quantity
  qualityNotes
  receiptEntryId
  receivedDate
  receiveLocationId
  shortageNotes
  varianceReason
  vendorLotNumber
}
fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`, {"fragmentName":"VendorPurchaseOrderDetailFields"});
export const GetVendorPurchaseOrdersDocument = new TypedDocumentString(`
    query GetVendorPurchaseOrders($first: Int, $after: String, $last: Int, $before: String, $where: VendorPurchaseOrderDocumentFilterInput, $order: [VendorPurchaseOrderDocumentSortInput!]) {
  vendorPurchaseOrders(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    nodes {
      ...VendorPurchaseOrderFields
    }
  }
}
    fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}
fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetVendorPurchaseOrderDocument = new TypedDocumentString(`
    query GetVendorPurchaseOrder($vendorPurchaseOrderId: String!) {
  vendorPurchaseOrderById(vendorPurchaseOrderId: $vendorPurchaseOrderId) {
    ...VendorPurchaseOrderDetailFields
  }
}
    fragment VendorPurchaseOrderItemFields on VendorPurchaseOrderItemData {
  erpJobId
  eventDetailId
  id
  isCostOverridden
  isOrganicAtReceive
  itemName
  lineNumber
  materialItemErpId
  materialItemId
  organicLotCode
  productionJobId
  productionJobNumber
  quantityOrdered
  quantityReceived
  unitCost
  unitCostText
  varianceReason
}
fragment VendorPurchaseOrderChargeFields on VendorPurchaseOrderChargeData {
  id
  label
  amount
}
fragment VendorPurchaseOrderReceiptFields on VendorPurchaseOrderReceiptData {
  itemId
  quantity
  qualityNotes
  receiptEntryId
  receivedDate
  receiveLocationId
  shortageNotes
  varianceReason
  vendorLotNumber
}
fragment VendorPurchaseOrderFields on VendorPurchaseOrderDocument {
  created
  erpId
  id
  orderPlacedDate
  purchaseOrderNumber
  siteLocationId
  status
  tenantId
  updated
  vendorId
  vendorName
  isUrgent
  estimatedSubtotal
  estimatedTotal
  needByDate
  shipWeek
  notes
  billingAddress {
    ...AddressData
  }
  shippingAddress {
    ...AddressData
  }
  items {
    ...VendorPurchaseOrderItemFields
  }
  charges {
    ...VendorPurchaseOrderChargeFields
  }
}
fragment VendorPurchaseOrderDetailFields on VendorPurchaseOrderDocument {
  ...VendorPurchaseOrderFields
  receipts {
    ...VendorPurchaseOrderReceiptFields
  }
}
fragment AddressData on AddressData {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}`);
export const GetVendorPurchaseOrderLineCostPreviewDocument = new TypedDocumentString(`
    query GetVendorPurchaseOrderLineCostPreview($vendorId: String!, $materialItemIds: [String!]!, $asOfDate: DateTime) {
  vendorPurchaseOrderLineCostPreview(
    vendorId: $vendorId
    materialItemIds: $materialItemIds
    asOfDate: $asOfDate
  ) {
    materialItemId
    unitCost
    unitCostText
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetVendorPurchaseOrders: build.query<GetVendorPurchaseOrdersQuery, GetVendorPurchaseOrdersQueryVariables | void>({
      query: (variables) => ({ document: GetVendorPurchaseOrdersDocument, variables })
    }),
    GetVendorPurchaseOrder: build.query<GetVendorPurchaseOrderQuery, GetVendorPurchaseOrderQueryVariables>({
      query: (variables) => ({ document: GetVendorPurchaseOrderDocument, variables })
    }),
    GetVendorPurchaseOrderLineCostPreview: build.query<GetVendorPurchaseOrderLineCostPreviewQuery, GetVendorPurchaseOrderLineCostPreviewQueryVariables>({
      query: (variables) => ({ document: GetVendorPurchaseOrderLineCostPreviewDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetVendorPurchaseOrdersQuery, useLazyGetVendorPurchaseOrdersQuery, useGetVendorPurchaseOrderQuery, useLazyGetVendorPurchaseOrderQuery, useGetVendorPurchaseOrderLineCostPreviewQuery, useLazyGetVendorPurchaseOrderLineCostPreviewQuery } = injectedRtkApi;
